import React from 'react';
import { content } from '../../content';
import { CheckIcon } from '../Icon';
import '../../styles/Sections.css';

const { about, author } = content;

const AboutSection = () => (
  <div className="section">
    <div className="about-top">
      <section className="panel about-intro">
        {about.intro.map((paragraph) => (
          <p key={paragraph.slice(0, 24)} className="about-intro__p">
            {paragraph}
          </p>
        ))}
        <p className="about-intro__sign">
          {author.name} — {author.role}
        </p>
      </section>

      <section className="panel about-facts">
        <h3 className="panel__title">{about.factsTitle}</h3>
        <dl className="facts">
          {about.facts.map((fact) => (
            <div key={fact.label} className="facts__row">
              <dt>{fact.label}</dt>
              <dd>{fact.value}</dd>
            </div>
          ))}
        </dl>
      </section>
    </div>

    <section className="panel">
      <header className="panel__head">
        <h3 className="panel__title">{about.timelineTitle}</h3>
        <p className="panel__caption">{about.timelineCaption}</p>
      </header>

      <ol className="timeline">
        {about.timeline.map((entry) => (
          <li key={entry.period} className="timeline__item">
            <span className="timeline__period">{entry.period}</span>
            <div className="timeline__body">
              <h4 className="timeline__title">{entry.title}</h4>
              <p className="timeline__text">{entry.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>

    <section className="panel">
      <header className="panel__head">
        <h3 className="panel__title">{about.currentlyTitle}</h3>
      </header>
      <ul className="checklist">
        {about.currently.map((item) => (
          <li key={item} className="checklist__item">
            <CheckIcon size={15} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>

    {/* What I am available for is a different statement from what I am
        learning, so it gets its own panel rather than the last bullet of
        the previous one. */}
    <section className="panel">
      <header className="panel__head">
        <h3 className="panel__title">{about.openTitle}</h3>
      </header>
      <ul className="checklist">
        {about.open.map((item) => (
          <li key={item} className="checklist__item">
            <CheckIcon size={15} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  </div>
);

export default AboutSection;
